import { useEffect, useState } from 'react'

import { useLogisticFilialsFilters } from 'hooks/useLogisticFilialsFilters'
import { useStores } from 'hooks/useStores'
import { logisticFilialsApi } from 'redux/services/logistic-filial'

import { AppLayout } from 'components/AppLayout'
import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { LogisticFilial } from 'models/logistic-filial'
import { UserRole } from 'models/user'

import { ReactComponent as UserCircleAddIcon } from 'assets/images/svg/user_circle_add.svg'

import { CreateLogisticCartModal } from './components/Create'
import { Details } from './components/Details'
import { EmptyDetails } from './components/EmptyDetails'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

enum ModalState {
  None,
  Create,
}

export function ContactCenterFillialsPage() {
  const { userStore } = useStores()
  const { params, setParam, resetParams } = useLogisticFilialsFilters()
  const [selectedRowId, setSelectedRowId] = useState<
    LogisticFilial['id'] | undefined
  >()
  const [modal, setModal] = useState<ModalState>(ModalState.None)
  const [fetch, fetchState] =
    logisticFilialsApi.useLazyGetLogisticFilialsQuery()

  const role = userStore.user?.role as UserRole

  useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.offset])

  const onSubmit = () => {
    fetch(params)
    setSelectedRowId(undefined)
  }
  const reset = () => {
    resetParams()
    fetch(params)
    setSelectedRowId(undefined)
  }

  const openModal = () => {
    setModal(ModalState.Create)
    document.body.style.overflow = 'hidden'
  }

  const closeModal = () => {
    setModal(ModalState.None)
    document.body.style.overflow = 'auto'
  }

  return (
    <>
      {[UserRole.ControllerUKC, UserRole.Specialist].includes(role) && (
        <AppLayout
          linksRight={[
            {
              title: 'Создать',
              icon: <UserCircleAddIcon />,
              onClick: openModal,
            },
          ]}
        />
      )}

      <AppLayoutTable
        title="Заявки"
        header={<Filters onSubmit={onSubmit} reset={reset} />}
        statistics={<Statistics />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              key={selectedRowId}
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}

        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              loading={fetchState.isFetching}
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                  width: 50,
                },
                {
                  data: 'Клиент',
                  key: 'client_full_name',
                  width: 50,
                },
                {
                  data: 'ПАН',
                  key: 'pan',
                  width: 50,
                },
                {
                  data: 'Статус',
                  key: 'get_status_display',
                  width: 50,
                },
                {
                  data: 'Тип',
                  key: 'get_cart_type_display',
                  width: 50,
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  width: 50,
                },
              ]}
            />

            <AppPagination
              forcePage={params.offset! / params.limit!}
              onPageChange={nextPage => {
                setParam('offset', String((nextPage - 1) * params.limit!))
              }}
              count={fetchState.data.count / params.limit!}
            />
          </>
        )}
      </AppLayoutTable>

      {modal === ModalState.Create && (
        <CreateLogisticCartModal onClose={closeModal} />
      )}
    </>
  )
}
